/**
 * @enum LvfEquipmentType
 *  * @classdesc Represents the supported Equipment Type Source.
 */
export enum LvfEquipmentType {

  GENERIC = 1,
  VEHICLE = 2,
  HANDLING = 3,
  MOBILE_BOX = 4,
  BUILDING = 5,
}

export function carriesVehicleExtension(family?: LvfEquipmentType): boolean {
  return family === LvfEquipmentType.VEHICLE;
}
